import React, { useState , useContext, useEffect} from 'react';
import { UserContext } from '../../UserContext';
import { AdminContext } from '../admin/AdminContext';
import { useNavigate } from 'react-router-dom';
import { Row , Col , Image, Container} from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import favicon from '../../assets/favicon.ico';
import Layout from '../layout/Layout';
import ServicesList from './ServicesList';
import  secureLocalStorage  from  "react-secure-storage";

const Home = ({  }) => {

    const {user, activeModule,setActiveModule} = useContext(UserContext);
    const {activeMenu} = useContext(AdminContext);
    const [loading, setLoading] = useState(false);
    const navigate= useNavigate();
    useEffect( () => {
        //if (!user) return navigate("/");
        setLoading(false);
    },[]);



    const benefitValidate = () => {
        setLoading(true);
    }
    const spinerRush  =  <Spinner className="align-middle" animation="grow"   variant="dark" role="status">
                        <Image rounded width={20} height={20} src={favicon} />
                    </Spinner>;
    return(
        <>
        <Layout>
            <Container fluid>
            <Row>
                <Col sm={12} md={12} lg={12}>
                   { activeMenu == 'service' &&  <ServicesList/> }
                </Col>
            </Row>
            </Container>

        </Layout>

        </>

    )
}
export default Home;